module.exports = __webpack_public_path__ + "img/Welding_Ring_Set.c758b934.png";